import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

const DIALOG_WIDTH = 960;

/* ---------------------------------------------------------------------------
 * Props
 * --------------------------------------------------------------------------- */

export default /*@__PURE__*/_defineComponent({
  __name: 'GuideCTA',
  props: {
    guideUrl: { type: String, required: false, default: "https://app.guideflow.com/embed/qkqdxyxu1p" }
  },
  emits: ["click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

/* ---------------------------------------------------------------------------
 * State
 * --------------------------------------------------------------------------- */
const isOpen = ref(false);
const isLoading = ref(true);

/* ---------------------------------------------------------------------------
 * Actions
 * --------------------------------------------------------------------------- */
function openGuide() {
  isLoading.value = true;
  isOpen.value = true;
  emit("click");
}

function closeGuide() {
  isOpen.value = false;
  isLoading.value = true; // reset for next open
}

function onIframeLoad() {
  isLoading.value = false;
}

const __returned__ = { DIALOG_WIDTH, props, emit, isOpen, isLoading, openGuide, closeGuide, onIframeLoad }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})